import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { PremiumFeature } from "@/components-legacy/premium-feature";
import { Button } from "@babackapp/ui/components/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@babackapp/ui/components/card";
import { Separator } from "@babackapp/ui/components/separator";
import { PlusIcon } from "@radix-ui/react-icons";
import { PropsWithChildren } from "react";
import { AddDomainDialog } from "./add-domain-dialog";
import { DomainListForm } from "./domains-list-form";
import { DomainListItem } from "./domains-list-item";
import useTranslation from "@babackapp/translations/use-translation";
import useShopDomains from "@babackapp/private-api-client/client/use-shop-domains";

export default function DomainsList() {
  const { data: shop } = useCurrentShopSuspense();
  const { data: domains } = useShopDomains(shop.id);
  const t = useTranslation();

  if (!shop) return null;

  if (!shop.plan.customDomain) {
    return (
      <Container>
        <PlanDoesNotAllow />
      </Container>
    );
  }

  const [defaultPreDomain, defaultDomain] =
    shop.preferences.notifications.emailFrom?.split("@") ?? [];

  return (
    <Container>
      <DomainListForm
        defaultValues={{
          email: {
            input: defaultPreDomain ?? "",
            select: defaultDomain ?? "",
          },
        }}
      />
      <Separator className="my-4" />
      <span className="text-xs text-muted-foreground px-2 uppercase font-semibold my-4">
        {t("settings.domains.headTitle")}
      </span>
      <div className="flex flex-col gap-2 mt-4 mb-8">
        {domains?.map((domain) => (
          <DomainListItem key={domain.name} domain={domain} />
        ))}
      </div>
      <AddDomainDialog>
        <Button variant="secondary" className="item-center flex gap-2">
          {t("settings.domains.add")}
          <PlusIcon />
        </Button>
      </AddDomainDialog>
    </Container>
  );
}

function Container({ children }: PropsWithChildren) {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();

  if (!shop) return null;
  return (
    <Card>
      <CardHeader className="flex flex-row justify-between">
        <div className="flex flex-1 flex-col gap-2">
          <CardTitle className="text-lg leading-6 font-medium text-gray-900">
            {t("settings.domains.title")}
          </CardTitle>
          <CardDescription>
            {t("settings.domains.subtitle", {
              domain: shop.email.split("@")?.[1],
            })}
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}

function PlanDoesNotAllow() {
  return <PremiumFeature />;
}
